import { c as __rest, _ as __assign, b as __spreadArray } from '../../../../tslib/tslib.es6-LMiJArAJ-BzgLaGEp.js';
import * as React from 'react';
import { D as DEFAULT_INTL_CONFIG, a as assignUniqueKeysToParts } from '../utils-BIG_B-Jx-BNoSNLtk.js';
import { c as createIntl$1 } from '../../../../_formatjs/intl/lib/src/create-intl-B7aoY7zY-jexxwCjA.js';
import { i as isFormatXMLElementFn } from '../../../../intl-messageformat/lib/src/formatters-ZXdgKY3m-DoZdCxm5.js';
import { f as formatMessage$1 } from '../../../../_formatjs/intl/lib/src/message-DkvPJxmq-5BcfdX56.js';

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */
function assignUniqueKeysToFormatXMLElementFnArgument(values) {
  if (!values) {
    return values;
  }
  return Object.keys(values).reduce(function (acc, k) {
    var v = values[k];
    acc[k] = isFormatXMLElementFn(v) ? assignUniqueKeysToParts(v) : v;
    return acc;
  }, {});
}
var formatMessage = function (config, formatters, descriptor, rawValues) {
  var rest = [];
  for (var _i = 4; _i < arguments.length; _i++) {
    rest[_i - 4] = arguments[_i];
  }
  var values = assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
  var chunks = formatMessage$1.apply(void 0, __spreadArray([config, formatters, descriptor, values], rest, false));
  if (Array.isArray(chunks)) {
    return React.Children.toArray(chunks);
  }
  return chunks;
};
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */
var createIntl = function (_a, cache) {
  var rawDefaultRichTextElements = _a.defaultRichTextElements,
    config = __rest(_a, ["defaultRichTextElements"]);
  var defaultRichTextElements = assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
  var coreIntl = createIntl$1(__assign(__assign(__assign({}, DEFAULT_INTL_CONFIG), config), {
    defaultRichTextElements: defaultRichTextElements
  }), cache);
  var resolvedConfig = {
    locale: coreIntl.locale,
    timeZone: coreIntl.timeZone,
    fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
    formats: coreIntl.formats,
    defaultLocale: coreIntl.defaultLocale,
    defaultFormats: coreIntl.defaultFormats,
    messages: coreIntl.messages,
    onError: coreIntl.onError,
    defaultRichTextElements: defaultRichTextElements
  };
  return __assign(__assign({}, coreIntl), {
    formatMessage: formatMessage.bind(null, resolvedConfig,
    // @ts-expect-error fix this
    coreIntl.formatters),
    // @ts-expect-error fix this
    $t: formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
  });
};

export { createIntl as c };
//# sourceMappingURL=createIntl-CF-rRoPw-DQ8TwHqP.js.map
